












































import Vue from 'vue'
export default Vue.extend({

  props: [ 'username' ],

  data() {
    return {
      currentPassword: '',
      newPassword: '',
      repeatNewPassword: '',
      errors: false,
      errorMessage: '',
      loading: false
    }
  },
  
  methods: {
    async login() {
      if (this.newPassword !== this.repeatNewPassword) {
        this.errors = true;
        this.errorMessage = 'Please make sure new passwords match'
        return
      }

      this.loading = true
      await this.$moonpull.firstTimeAccountSetup(this.username, this.currentPassword, this.newPassword)
      this.loading = false
    }
  },

  async beforeCreate() {
    if (await this.$moonpull.isLoggedIn()) {
      this.$router.push({ name: 'dashboard' })
    }
  },

  beforeMount() {
    if (! this.username) {
      this.$router.push({ name: 'login' })
    }
  }

})
